export const SUPABASE_BUCKETS = {
    avatars: 'avatars',
    serverAssets: 'server-assets',
    emojis: 'emojis',
    stickers: 'stickers',
    /** Private desktop installers — signed download URLs only. */
    updates: 'updates',
};
export const R2_ATTACHMENTS_BUCKET = 'attachments';
/** Extensions that must never be rendered inline in the browser. */
export const BLOCKED_UPLOAD_EXTENSIONS = new Set([
    'html',
    'htm',
    'js',
    'mjs',
    'cjs',
    'php',
    'asp',
    'aspx',
    'cgi',
    'svg',
]);
/** Chat attachment extensions (lowercase, without dot). */
export const ATTACHMENT_EXTENSIONS = new Set([
    'png',
    'jpg',
    'jpeg',
    'webp',
    'gif',
    'mp4',
    'webm',
    'zip',
    'rar',
    '7z',
    'pdf',
    'txt',
    'doc',
    'docx',
    'xls',
    'xlsx',
    'exe',
    'apk',
]);
export const PROFILE_IMAGE_EXTENSIONS = new Set(['png', 'jpg', 'jpeg', 'webp', 'gif']);
/** Profile avatar / banner: images (incl. GIF) + short MP4 loops */
export const PROFILE_MEDIA_EXTENSIONS = new Set([...PROFILE_IMAGE_EXTENSIONS, 'mp4']);
/** File input `accept` for avatar / banner uploads */
export const PROFILE_MEDIA_FILE_ACCEPT = '.png,.jpg,.jpeg,.webp,.gif,.mp4,image/png,image/jpeg,image/webp,image/gif,video/mp4';
/** Max size for profile GIF and MP4 (avatar or banner). */
export const PROFILE_GIF_MP4_MAX_BYTES = 50 * 1024 * 1024;
/** @deprecated Alias for {@link PROFILE_GIF_MP4_MAX_BYTES} */
export const PROFILE_MP4_MAX_BYTES = PROFILE_GIF_MP4_MAX_BYTES;
export const UPLOAD_SIZE_LIMITS = {
    image: 25 * 1024 * 1024,
    video: 250 * 1024 * 1024,
    document: 100 * 1024 * 1024,
    archive: 500 * 1024 * 1024,
    profile: 8 * 1024 * 1024,
    emoji: 2 * 1024 * 1024,
};
export function extensionFromFilename(name) {
    const base = name.split(/[/\\]/).pop() ?? name;
    const idx = base.lastIndexOf('.');
    if (idx < 0)
        return '';
    return base.slice(idx + 1).toLowerCase();
}
export function categoryForAttachment(ext) {
    if (['png', 'jpg', 'jpeg', 'webp', 'gif'].includes(ext))
        return 'image';
    if (['mp4', 'webm'].includes(ext))
        return 'video';
    if (['zip', 'rar', '7z'].includes(ext))
        return 'archive';
    return 'document';
}
export function isInlineRenderableMime(mime) {
    return mime.startsWith('image/') || mime.startsWith('video/');
}
/** Client-side check before uploading avatar / banner. Returns an error message or null if OK. */
export function validateProfileMediaFile(file) {
    const ext = extensionFromFilename(file.name);
    if (!ext)
        return 'File must have an extension (e.g. .png, .gif, .mp4)';
    if (!PROFILE_MEDIA_EXTENSIONS.has(ext)) {
        return `Unsupported file type (.${ext}). Use PNG, JPG, WebP, GIF, or MP4.`;
    }
    if (file.size <= 0)
        return 'File is empty';
    if (ext === 'mp4' || ext === 'gif') {
        if (file.size > PROFILE_GIF_MP4_MAX_BYTES) {
            const mb = Math.round(PROFILE_GIF_MP4_MAX_BYTES / (1024 * 1024));
            return `${ext === 'gif' ? 'GIF' : 'Video'} must be under ${mb} MB`;
        }
        return null;
    }
    const max = UPLOAD_SIZE_LIMITS.profile;
    if (file.size > max) {
        const mb = Math.round(max / (1024 * 1024));
        return `Image must be under ${mb} MB`;
    }
    return null;
}
/** True when a profile avatar/banner URL points at an MP4 asset. */
export function isProfileVideoUrl(url) {
    const trimmed = url.trim();
    if (!trimmed)
        return false;
    try {
        const parsed = new URL(trimmed, 'https://local.invalid');
        return extensionFromFilename(parsed.pathname) === 'mp4';
    }
    catch {
        return extensionFromFilename(trimmed.split('?')[0] ?? trimmed) === 'mp4';
    }
}
//# sourceMappingURL=upload.js.map